import {Icon, Spacer, Text, Theme} from "@dspworkplace/ui";
import React from "react";
import jsonQuery from 'json-query';

const ValueFormatter = ({children}) =>
    <Spacer
        left={2}
        style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
        }}
    >
        <Text>{children}</Text>
    </Spacer>

export const SimpleFormatter = ({row, column}) => {
    let value = jsonQuery(column.key, {data: row}).value;

    if (column._dropdown){
        value = column._dropdown.options.find(s => s.value === value)?.label;
        if(!value){
            value = column._dropdown?.default?.label
        }
    }
    

    return <ValueFormatter>{value}</ValueFormatter>
}

export const RecommendedFormatter = ({row, column, ...rest}) => {
    if (jsonQuery(column.key, {data: row}).value)
        return SimpleFormatter({row, column, ...rest})

    return (
        <Spacer all={2} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            backgroundColor: Theme.colors.warnings.bg
        }}>
            <Icon.Warning
                size='16px'
                color={Theme.colors.warnings.text}
            />
            <Text
                style={{
                    color: Theme.colors.warnings.text,
                }}
            >Recommended</Text>
        </Spacer>
    )
}

export const RequiredFormatter = ({row, column, ...rest}) => {
    if (jsonQuery(column.key, {data: row}).value)
        return SimpleFormatter({row, column, ...rest})

    return (
        <Spacer all={2} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            backgroundColor: Theme.colors.error.bg
        }}>
            <Icon.Warning
                size='16px'
                color={Theme.colors.error.text}
            />
            <Text
                style={{
                    color: Theme.colors.error.text,
                }}
            >Required</Text>
        </Spacer>
    )
}